import * as React from "react";

export default () => (
  <article>
    <section>
      <h1>Mentions légales</h1>
      <p>En vigueur au 01/06/2020</p>
      <p>
        Conformément aux dispositions des Articles 6-III et 19 de la Loi
        n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique,
        dite L.C.E.N., il est porté à la connaissance des Utilisateurs du site
        le-c.fr les présentes mentions légales. La connexion et la navigation
        sur le site (indiquer le nom du site) par l’Utilisateur implique
        acceptation intégrale et sans réserve des présentes mentions légales.
        Ces dernières sont accessibles sur le site à la rubrique « Mentions
        légales ».
      </p>
    </section>
    <section>
      <h2>ARTICLE 1 : L’éditeur</h2>
      <p>
        L’édition et la direction de la publication du site le-c.fr est assurée
        par Matthieu Hocquart, domiciliée 32 Rue de montreuil 75011, dont
        l'adresse e-mail matthieu@hocquart.fr.
      </p>
    </section>

    <section>
      <h2>ARTICLE 2 : L’hébergeur</h2>
      <p>
        L'hébergeur du site le-c.fr est la Société OVH SAS, dont le siège social
        est situé au 2 rue Kellermann - 59100 Roubaix - France.
      </p>
    </section>
    <section>
      <h2>ARTICLE 3 : Accès au site</h2>
      <p>
        Le site est accessible par tout endroit, 7j/7, 24h/24 sauf cas de force
        majeure, interruption programmée ou non et pouvant découlant d’une
        nécessité de maintenance.
      </p>
    </section>
    <section>
      <h2>ARTICLE 3 : Accès au site</h2>
      <p>
        Le site est accessible par tout endroit, 7j/7, 24h/24 sauf cas de force
        majeure, interruption programmée ou non et pouvant découlant d’une
        nécessité de maintenance.
      </p>
      <p>
        En cas de modification, interruption ou suspension des services le site
        le-c.fr ne saurait être tenu responsable.
      </p>
    </section>
    <section>
      <h2>ARTICLE 4 : Collecte des données</h2>
      <p>
        Le site est exempté de déclaration à la Commission Nationale
        Informatique et Libertés (CNIL) dans la mesure où il ne collecte aucune
        donnée concernant les utilisateurs.
      </p>
    </section>
    <section>
      <h2>ARTICLE 5 : Cookies</h2>
      <p>
        L’Utilisateur est informé que lors de ses visites sur le site, un cookie
        peut s’installer automatiquement sur son logiciel de navigation.
      </p>
      <p>En naviguant sur le site, il les accepte.</p>
      <p>
        Un cookie est un élément qui ne permet pas d’identifier l’Utilisateur
        mais sert à enregistrer des informations relatives à la navigation de
        celui-ci sur le site Internet. L’Utilisateur pourra désactiver ce cookie
        par l’intermédiaire des paramètres figurant au sein de son logiciel de
        navigation.
      </p>
    </section>
    <section>
      <h2>ARTICLE 6 : Propriété intellectuelle</h2>
      <p>
        Toute utilisation, reproduction, diffusion, commercialisation,
        modification de toute ou partie du site le-c.fr, sans autorisation de
        l’Editeur est prohibée et pourra entraînée des actions et poursuites
        judiciaires telles que notamment prévues par le Code de la propriété
        intellectuelle et le Code civil.
      </p>
    </section>
  </article>
);
